import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";
import OrganisationIndexGroupMapper from "../service/OrganisationIndexGroupMapper";
import OrganisationIndexGroupParamMapper from "../service/OrganisationIndexGroupParamMapper";

export default class GetAllOrganisationIndexGroupsInteractor {
  private resource: GetAllResourceEntriesInteractor<IOrganisationIndexGroup>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(organisationId: number) {
    return this.resource.execute(
      `organisations/${organisationId}/index-groups`,
      OrganisationIndexGroupMapper,
      OrganisationIndexGroupParamMapper
    );
  }
}
